import Cookies from 'js-cookie';
import actions from './actions';

const { INITIAL, LOGIN_BEGIN, LOGIN_SUCCESS, LOGIN_ERR, LOGOUT_BEGIN, LOGOUT_SUCCESS, LOGOUT_ERR, FORGOT_BEGIN,FORGOT_SUCCESS,FORGOT_ERR,OTP_BEGIN,OTP_SUCCESS,OTP_ERR,CHANGE_BEGIN,CHANGE_SUCCESS,CHANGE_ERR,  CHECK_STORE_BEGIN, CHECK_STORE_SUCCESS, CHECK_STORE_ERR, SURVEY_QUIZ_BEGIN, SURVEY_QUIZ_SUCCESS, SURVEY_QUIZ_ERR, SURVEY_QUIZ_SKIP_BEGIN, SURVEY_QUIZ_SKIP_SUCCESS, SURVEY_QUIZ_SKIP_ERR, SURVEY_QUIZ_UPDATE_TOKEN_BEGIN, SURVEY_QUIZ_UPDATE_TOKEN_SUCCESS, SURVEY_QUIZ_UPDATE_TOKEN_ERR, SURVEY_QUIZ_SUBMIT_BEGIN, SURVEY_QUIZ_SUBMIT_SUCCESS, SURVEY_QUIZ_SUBMIT_ERR, SURVEY_QUIZ_SNOOZED, SURVEY_QUIZ_RESET } = actions;

const initState = {
    login: Cookies.get('SangLoggedIn'),
    loading: false,
    error: null,
    loginData: Cookies.get('SangLoggedData') ? JSON.parse(Cookies.get('SangLoggedData')) : '',
};

const authReducer = (state = initState, action) => {
    const { type, data,loginData, err } = action;
    switch (type) {
        case LOGIN_BEGIN:
            return {
                ...state,
                error:'',
                login:'',
                loginData: '',
                loading: true,
            };
        case LOGIN_SUCCESS:
            return {
                ...state,
                login: data,
                loginData: loginData,
                loading: false,
            };
        case LOGIN_ERR:
            return {
                ...state,
                error: err,
                login: '',
                loginData: '',
                loading: false,
            };
        
        case LOGOUT_BEGIN:
            return {
                ...state,
                error:'',
                login: '',
                loginData: '',
                loading: true,
            };
        case LOGOUT_SUCCESS:
            return {
                ...state,
                error:'',
                login: '',
                loginData: '',
                loading: false,
            };
        case LOGOUT_ERR:
            return {
                ...state,
                error: err,
                login: '',
                loginData: '',
                loading: false,
            };
        default:
            return state;
    }
};


const initStateForgot = {
    type:'forgot', 
    loading: false,
    error: null,
    forgot:false,
    otp:false,
    change:false,
};

const forgotReducer = (state = initStateForgot, action) => {
    const { type, data, err, username } = action;
    switch (type) {
        case FORGOT_BEGIN:
            return {
                ...state,
                error:'',
                loading: true,
            };
        case FORGOT_SUCCESS:
            return {
                ...state,
                type:'otp',
                forgot:data,
                username:username,
                loading: false,
            };
        case FORGOT_ERR:
            return {
                ...state,
                error: err,
                loading: false,
            };
        
        case OTP_BEGIN:
            return {
                ...state,
                error:'',
                loading: true,
            };
        case OTP_SUCCESS:
            return {
                ...state,
                type:'change',
                otp:data,
                loading: false,
            };
        case OTP_ERR:
            return {
                ...state,
                error: err,
                loading: false,
            };

        case CHANGE_BEGIN:
            return {
                ...state,
                error:'',
                loading: true,
            };
        case CHANGE_SUCCESS:
            return {
                ...state,
                type:'forgot',
                change:true,
                loading: false,
            };
        case CHANGE_ERR:
            return {
                ...state,
                error: err,
                loading: false,
            };
            
        case INITIAL:
            return initStateForgot;
            
        default:
            return state;
    }
};

const initStateStorePermission = {
  status: 'idle',      
  allowed: null,       
  error: null,
  router: null,
  lockType: '',
  details: null,
  gateMeetingReport: '',
  isTvDownloaded: null,
};

const storePermissionReducer = (state = initStateStorePermission, action) => {
    const { type, allowed, err, router, lockType, message, details, gateMeetingReport, isTvDownloaded } = action;
    switch (type) {
        case CHECK_STORE_BEGIN:
            return {
                ...state,
                status: 'loading',
                allowed: null,
                error: null,
                router,
                lockType: '',
                details: null,
                gateMeetingReport: '',
                isTvDownloaded: null,
            };

        case CHECK_STORE_SUCCESS:
            return {
                ...state,
                status: 'succeeded',
                allowed: allowed,  
                error: message || null,
                router,
                lockType,
                details,
                gateMeetingReport,
                isTvDownloaded,
            };

        case CHECK_STORE_ERR:
            return {
                ...state,
                status: 'failed',
                allowed: false,
                error: err,
                router,
                lockType,
                gateMeetingReport: '',
                isTvDownloaded: null,
            };

        case LOGIN_BEGIN:
        case LOGOUT_BEGIN:
        case LOGOUT_SUCCESS:
            return initStateStorePermission;

        default:
            return state;
    }
};

const initStateSurveyQuiz = {
  status: 'idle',
  required: false,
  processing: false,
  error: null,
  router: null,
  uniqueToken: '',
  surveyId: '',
  questions: [],
  checkAlreadyAttend: '',
  displayMesssage: '',
  snoozeLimit: '',
  snoozedCount: '',
  isSkippable: '',
  message: '',
  skipLoading: false,
  skipData: null,
  updateTokenLoading: false,
  updateTokenData: null,
  submitLoading: false,
  submitData: null,
};

const surveyQuizReducer = (state = initStateSurveyQuiz, action) => {
    const { type, data, err, router, uniqueToken } = action;
    switch (type) {
        case SURVEY_QUIZ_BEGIN:
            return {
                ...state,
                status: 'loading',
                error: null,
                skipLoading: false,
                updateTokenLoading: false,
                submitLoading: false,
                router,
            };

        case SURVEY_QUIZ_SUCCESS:
            return {
                ...state,
                status: 'succeeded',
                required: data?.required,
                processing: data?.processing,
                error: null,
                router,
                uniqueToken,
                surveyId: data?.surveyId,
                questions: data?.questions,
                checkAlreadyAttend: data?.checkAlreadyAttend,
                displayMesssage: data?.displayMesssage,
                snoozeLimit: data?.snoozeLimit,
                snoozedCount: data?.snoozedCount,
                isSkippable: data?.isSkippable,
                message: data?.message,
                skipLoading: false,
                updateTokenLoading: false,
                submitLoading: false,
            };

        case SURVEY_QUIZ_ERR:
            return {
                ...state,
                status: 'failed',
                required: false,
                processing: false,
                error: err,
                router,
                skipLoading: false,
                updateTokenLoading: false,
                submitLoading: false,
            };

        case SURVEY_QUIZ_SKIP_BEGIN:
            return {
                ...state,
                error: null,
                skipLoading: true,
            };

        case SURVEY_QUIZ_SKIP_SUCCESS:
            return {
                ...state,
                required: false,
                processing: false,
                error: null,
                skipLoading: false,
                skipData: data,
            };

        case SURVEY_QUIZ_SKIP_ERR:
            return {
                ...state,
                error: err,
                skipLoading: false,
            };

        case SURVEY_QUIZ_UPDATE_TOKEN_BEGIN:
            return {
                ...state,
                error: null,
                updateTokenLoading: true,
            };

        case SURVEY_QUIZ_UPDATE_TOKEN_SUCCESS:
            return {
                ...state,
                error: null,
                updateTokenLoading: false,
                updateTokenData: data,
            };

        case SURVEY_QUIZ_UPDATE_TOKEN_ERR:
            return {
                ...state,
                error: err,
                updateTokenLoading: false,
            };

        case SURVEY_QUIZ_SUBMIT_BEGIN:
            return {
                ...state,
                error: null,
                submitLoading: true,
            };

        case SURVEY_QUIZ_SUBMIT_SUCCESS:
            return {
                ...state,
                required: false,
                processing: false,
                error: null,
                submitLoading: false,
                submitData: data,
            };

        case SURVEY_QUIZ_SUBMIT_ERR:
            return {
                ...state,
                error: err,
                submitLoading: false,
            };

        case SURVEY_QUIZ_SNOOZED:
            return {
                ...state,
                status: 'succeeded',
                required: false,
                processing: false,
                error: null,
                router,
                uniqueToken,
                skipLoading: false,
                updateTokenLoading: false,
                submitLoading: false,
            };

        case SURVEY_QUIZ_RESET:
        case LOGIN_BEGIN:
        case LOGOUT_SUCCESS:
            return initStateSurveyQuiz;

        default:
            return state;
    }
};

export { authReducer, forgotReducer, storePermissionReducer, surveyQuizReducer} ;
